module.exports = __webpack_public_path__ + "img/advantage3.f245432c.svg";